// import React from "react";
// import { ReactP5Wrapper } from "react-p5-wrapper";


// const Entwined = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {

//   const sketch = (p) => {
//     let BLACK = [51, 51, 51];
//     let PINK = [235, 93, 123];
//     let BLUE = [93, 105, 235];
//     let BEIGE = [255, 254, 246];

//     let t = 0;
//     let maxPoints = 490;
//     let feelWidths = [];
//     let doWidths = [];
//     let spaceKerning = 4.75;
//     let latoFont = "Lato";

//     // Camera State
//     let camX = 0;
//     let camY = 0;

//     let firstText = "The paths converged. The distance closed.";
//     let secondText = "All distinction dissolved into one seamless thread.";

//     const letter_extra_space = {
//       a: 1.05, b: 1, e: 1.5, l: 0.1, r: -0.2, s: 2, L: 0.5
//       // ... (keeping your existing kerning object)
//     };

//     p.setup = () => {
//       p.createCanvas(wt, ht);
//       p.rectMode(p.CENTER);
//       p.ellipseMode(p.CENTER);
//       p.textSize(fs);
//       p.textFont("Lato");

//       // Precompute widths (Simplified for brevity, keep your original loop)
//       firstText.split("").forEach((char, i) => {
//         const w = p.textWidth(char);
//         feelWidths[i] = w + (char === " " ? spaceKerning : letter_extra_space[char] || 0);
//       });
//       secondText.split("").forEach((char, i) => {
//         const w = p.textWidth(char);
//         doWidths[i] = w + (char === " " ? spaceKerning : letter_extra_space[char] || 0);
//       });
//     };

//     function drawMain() {

//       // 1. CALCULATE TIP POSITION (The lead point)
//       let progress = t / maxPoints;

//       let startX = 0;
//       let endX = 0;

//       let startY = p.height / 3;
//       let endY = -p.height - 200;

//       // The line tip position in "local" space (before rotation)
//       let tipX = p.lerp(startX, endX, progress);
//       let tipY = p.lerp(startY, endY, progress);

//       // 2. CONVERT TO ROTATED WORLD SPACE
//       // Since you rotate(PI/4), we apply that math to the camera target
//       let angleRad = p.PI / 2.5;
//       let rotatedTipX = tipX * p.cos(angleRad) - tipY * p.sin(angleRad);
//       let rotatedTipY = tipX * p.sin(angleRad) + tipY * p.cos(angleRad);

//       // 3. SMOOTH CAMERA FOLLOW
//       // We only start following after progress > 0.5 (when they merge)
//       // We subtract the tip position from the center of the screen
//       if (progress > 0.5) {
//         let targetCamX = -rotatedTipX;
//         let targetCamY = -rotatedTipY;
//         camX = p.lerp(camX, targetCamX, 0.05);
//         camY = p.lerp(camY, targetCamY, 0.05);
//       }
//       else {
//         // Reset camera when animation restarts
//         camX = p.lerp(camX, 0, 0.1);
//         camY = p.lerp(camY, 0, 0.1);
//       }

//       p.push();
//       // Apply Camera movement + Initial Center Offset
//       p.translate(p.width / 2 + camX, p.height / 2 + camY);
//       p.rotate(angleRad);

//       // Draw Pink Spiral
//       drawSpiral(p, t, PINK, startX, startY, endX, endY, 1);
//       // Draw Blue Spiral
//       drawSpiral(p, t, BLUE, startX, startY, endX, endY, -1);

//       p.pop();

//       t += 0.75;
//       if (t > maxPoints) t = 0;
//     }

//     // Helper to keep code clean
//     function drawSpiral(p, t, col, sX, sY, eX, eY, side) {
//       p.strokeWeight(8);
//       p.noFill();
//       p.beginShape();
//       for (let i = 0; i < t; i++) {
//         let prog = i / maxPoints;
//         let alpha = p.lerp(255, 100, i / (t + 50));
//         p.stroke(col[0], col[1], col[2], alpha);

//         let angle = i * 0.3 * side;
//         let radius = p.lerp(55, 0.1, p.constrain(prog / 0.5, 0, 1));

//         let x = p.lerp(sX, eX, prog) + radius * p.cos(angle);
//         let y = p.lerp(sY, eY, prog) + radius * p.sin(angle);
//         p.vertex(x, y);
//       }
//       p.endShape();
//     }



//     const statictext = () => {
//       p.push();
//       p.textSize(fs);
//       p.textFont(latoFont);
//       p.textAlign(p.LEFT, p.CENTER);
//       p.fill(BLACK);

//       let cx = p.width / 2;
//       let firstY = p.height - 120;
//       let secondY = firstY + 24;

//       let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
//       let secondWidth = doWidths.reduce((a, b) => a + b, 0);

//       let x = cx - firstWidth / 2;
//       for (let i = 0; i < firstText.length; i++) {
//         p.text(firstText[i], x, firstY);
//         x += feelWidths[i];
//       }

//       x = cx - secondWidth / 2;
//       for (let i = 0; i < secondText.length; i++) {
//         p.text(secondText[i], x, secondY);
//         x += doWidths[i];
//       }

//       p.pop();
//     };

//     p.draw = () => {
//       p.background(...BEIGE);
//       drawMain();
//       statictext();
//     };

//     return () => {
//       p.remove();
//     };
//   };

//   return <div style={{ backgroundColor: bgcolor, overflow: 'hidden' }}>
//     <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
//       <ReactP5Wrapper sketch={sketch} />
//     </div>
//   </div>

// };

// export default Entwined;


import React from "react";
import { ReactP5Wrapper } from "react-p5-wrapper";

function grid(p){
  const GRID_COLOR = [200, 200, 200, 80]; // Light gray with low alpha
  p.push();
  p.stroke(...GRID_COLOR);
  p.strokeWeight(1);
  let step = 40; // Size of grid squares

  // Draw grid much larger than canvas so it doesn't "run out" during camera movement
  let gridSize = 2000;
  for (let x = -gridSize; x <= gridSize; x += step) {
      p.line(x, -gridSize, x, gridSize);
  }
  for (let y = -gridSize; y <= gridSize; y += step) {
      p.line(-gridSize, y, gridSize, y);
  }
  p.pop();
}

const Entwined = ({ p5ref, wt, ht, scale, fs, bgcolor }) => {

  const sketch = (p) => {
    let BLACK = [51, 51, 51];
    let PINK = [235, 93, 123];
    let BLUE = [93, 105, 235];
    let BEIGE = [255, 254, 246];

    let t = 0;
    let maxPoints = 490;
    let feelWidths = [];
    let doWidths = [];
    let spaceKerning = 4.75;
    let latoFont = "Lato";

    let camX = 0;
    let camY = 0;

    let firstText = "The paths converged. The distance closed.";
    let secondText = "All distinction dissolved into one seamless thread.";

    const letter_extra_space = {
      a: 1.05, b: 1, e: 1.5, l: 0.1, r: -0.2, s: 2, L: 0.5
    };

    p.setup = () => {
      p.createCanvas(wt, ht);
      p.rectMode(p.CENTER);
      p.ellipseMode(p.CENTER);
      p.textSize(fs);
      p.textFont("Lato");

      firstText.split("").forEach((char, i) => {
        const w = p.textWidth(char);
        feelWidths[i] = w + (char === " " ? spaceKerning : letter_extra_space[char] || 0);
      });
      secondText.split("").forEach((char, i) => {
        const w = p.textWidth(char);
        doWidths[i] = w + (char === " " ? spaceKerning : letter_extra_space[char] || 0);
      });
    };


    function drawMain() {
      let progress = t / maxPoints;
      let startX = 0;
      let endX = 0;
      let startY = p.height / 3;
      let endY = -p.height - 200;

      let tipX = p.lerp(startX, endX, progress);
      let tipY = p.lerp(startY, endY, progress);

      let angleRad = p.PI / 2.5;
      let rotatedTipX = tipX * p.cos(angleRad) - tipY * p.sin(angleRad);
      let rotatedTipY = tipX * p.sin(angleRad) + tipY * p.cos(angleRad);

      if (progress > 0.5) {
        let targetCamX = -rotatedTipX;
        let targetCamY = -rotatedTipY;
        camX = p.lerp(camX, targetCamX, 0.05);
        camY = p.lerp(camY, targetCamY, 0.05);
      } 
      else {
        camX = p.lerp(camX, 0, 0.1);
        camY = p.lerp(camY, 0, 0.1);
      }

      p.push();
      p.translate(p.width / 2 + camX, p.height / 2 + camY);
      
      // Draw the grid BEFORE the lines but AFTER translation
      // This makes the grid feel like the "ground" the lines are on

      p.rotate(angleRad);
      drawSpiral(p, t, PINK, startX, startY, endX, endY, 1);
      drawSpiral(p, t, BLUE, startX, startY, endX, endY, -1);
      p.pop();

      t += 0.75;
      if (t > maxPoints) t = 0;
    }

    function drawSpiral(p, t, col, sX, sY, eX, eY, side) {
      p.strokeWeight(8);
      p.noFill();
      p.beginShape();
      for (let i = 0; i < t; i++) {
        let prog = i / maxPoints;
        let alpha = p.lerp(255, 100, i / (t + 50));
        p.stroke(col[0], col[1], col[2], alpha);
        let angle = i * 0.3 * side;
        let radius = p.lerp(55, 0.1, p.constrain(prog / 0.5, 0, 1));
        let x = p.lerp(sX, eX, prog) + radius * p.cos(angle);
        let y = p.lerp(sY, eY, prog) + radius * p.sin(angle);
        p.vertex(x, y);
      }
      p.endShape();
    }

    const statictext = () => {
      p.push();
      p.textSize(fs);
      p.textFont(latoFont);
      p.textAlign(p.LEFT, p.CENTER);
      p.fill(BLACK);
      let cx = p.width / 2;
      let firstY = p.height - 120;
      let secondY = firstY + 24;
      let firstWidth = feelWidths.reduce((a, b) => a + b, 0);
      let secondWidth = doWidths.reduce((a, b) => a + b, 0);
      let x = cx - firstWidth / 2;
      for (let i = 0; i < firstText.length; i++) {
        p.text(firstText[i], x, firstY);
        x += feelWidths[i];
      }
      x = cx - secondWidth / 2;
      for (let i = 0; i < secondText.length; i++) {
        p.text(secondText[i], x, secondY);
        x += doWidths[i];
      }
      p.pop();
    };

    p.draw = () => {
      p.background(...BEIGE);
      grid(p);
      drawMain();
      statictext();
    };

    return () => {
      p.remove();
    };
  };

  return (
    <div style={{ backgroundColor: bgcolor, overflow: 'hidden' }}>
      <div ref={p5ref} style={{ transform: `scale(${scale})` }}>
        <ReactP5Wrapper sketch={sketch} />
      </div>
    </div>
  );
};

export default Entwined;